import {
  LOGIN,
  LOGOUT,
  SET_USER_ADACCOUNTS,
  SET_USER_ACCOUNTS,
  TOGGLE_SETUP_MODE,
  SET_USER_AGENCY,
  SET_ACCOUNT_PIXELS,
  SET_FIREBASE_ACCOUNT
} from './mutations-types'
import * as Sentry from '@sentry/browser'

export default {
  [LOGIN] (state, payload) {
    Sentry.configureScope(scope => {
      scope.setUser({ id: payload.firebaseAccount.id, name: payload.name })
    })
    state.currentUser = payload
  },
  [LOGOUT] (state) {
    state.currentUser = null
  },
  [SET_USER_ADACCOUNTS] (state, payload) {
    state.currentUser = {}
    state.currentUser.adAccounts = payload
  },
  [SET_USER_ACCOUNTS] (state, payload) {
    state.currentUser.accounts = payload
  },
  [TOGGLE_SETUP_MODE] (state, payload) {
    let user = JSON.parse(localStorage.getItem('outfoxUser'))
    if (user) {
      user.selectedAdvertiser = payload
      user.setupMode = false
    }
    localStorage.setItem('outfoxUser', JSON.stringify(user))
    state.currentUser.selectedAdvertiser = payload
  },
  [SET_USER_AGENCY] (state, payload) {
    let user = JSON.parse(localStorage.getItem('outfoxUser'))
    if (user) user.selectedAgency = payload
    localStorage.setItem('outfoxUser', JSON.stringify(user))
    state.currentUser.selectedAgency = payload
  },
  [SET_ACCOUNT_PIXELS] (state, payload) {
    let user = JSON.parse(localStorage.getItem('outfoxUser'))
    user.pixels = payload
    localStorage.setItem('outfoxUser', JSON.stringify(user))
    state.currentUser.pixels = payload
  },
  [SET_FIREBASE_ACCOUNT] (state, payload) {
    state.currentUser.firebaseAccount = payload
  }
}
